import React, { useState } from 'react';
import { sendSignInLinkToEmail } from 'firebase/auth';
import { getFirebaseAuth } from '../firebase-init';
import toast from 'react-hot-toast';

const actionCodeSettings = {
  url: `${window.location.origin}/finishSignIn`,
  handleCodeInApp: true,
  android: { packageName: 'com.mednudge', installApp: true, minimumVersion: '1' },
};

export default function Setup() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const trimmed = email.trim();
      await sendSignInLinkToEmail(getFirebaseAuth(), trimmed, actionCodeSettings);
      window.localStorage.setItem('mt_pending_email', trimmed);
      setSent(true);
    } catch (err) {
      toast.error('Could not send sign-in link. Check the email address and try again.');
    } finally {
      setLoading(false);
    }
  }

  if (sent) {
    return (
      <div className="setup-screen">
        <div className="setup-card">
          <h1>💊 MedNudge</h1>
          <p>Check your email — we sent a sign-in link to <strong>{email}</strong>.</p>
          <p>Open it on this device to finish signing in.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="setup-screen">
      <div className="setup-card">
        <h1>💊 MedNudge</h1>
        <p>Enter your email to get a sign-in link.</p>
        <form onSubmit={handleSubmit}>
          <label>
            Email
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </label>
          <button type="submit" disabled={loading || !email.trim()}>
            {loading ? 'Sending…' : 'Send sign-in link'}
          </button>
        </form>
      </div>
    </div>
  );
}
